<template>
  <ScrollTop
    v-if="showScrollTop && !store.loading"
    scroll-watch-target="#articles-data"
  />
  <div class="englobe-params">
    <div class="params-row top">
      <FiltersMenu
        :active-filters="activeFilters"
        :is-loading="!store.filters"
        @remove-filter="removeFilterItem"
        @reset-all-filters="resetAllFilters"
      >
        <SelectMultipleCounter
          v-for="(value, key) in filtersNames"
          :key="key"
          :filter="key"
          :items="store.filters[key]"
          :active-filters="selectedFilters[key]"
          has-search
          @add-filter-item="addFilterItem"
          @remove-filter-item="removeFilterItem"
          @reset-filter="resetFilter"
        >
          {{ value }}
        </SelectMultipleCounter>
      </FiltersMenu>
    </div>

    <div class="social-media-article__title">
      <p class="title-large-semibold">Articles partagés via des posts sur</p>
      <i
        class="fa-brands fa-lg fa-square-x-twitter"
        :style="'color: var(--clr-twitter)'"
      />
    </div>

    <div class="params-row">
      <TotalMatched :item-count="store.item_count" feminine />
      <div class="page-settings">
        <DropdownMenu
          v-model="selectedSorterOption"
          :options="sortersOptions"
          label="Trier par :"
        />
        <DropdownMenu
          v-model="selectedLimitOption"
          :options="limitOptions"
          label="Articles par page :"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";

import FiltersMenu from "@follaw-fr/components/filter-menu/organisms/FiltersMenu.vue";
import SelectMultipleCounter from "@follaw-fr/components/filter-menu/molecules/SelectMultipleCounter.vue";
import TotalMatched from "@follaw-fr/components/reusable/atoms/TotalMatched.vue";
import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import { useDropdown } from "@follaw-fr/composables/useDropdown";
import { useTwitterArticlesStore } from "@follaw-fr/stores/social-media/articles";

const store = useTwitterArticlesStore();
const { selectedFilters } = storeToRefs(store);

const fetchArticles = async () => {
  selectedFilters.value.from = 0;
  await store.fetchTwitterArticlesList();
};

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters,
    filterKey: "size",
    onChange: () => {
      fetchArticles();
    },
  });

const { options: sortersOptions, selectedValue: selectedSorterOption } =
  useDropdown({
    options: {
      number_of_tweets: "Nombre de tweets",
      number_of_retweets: "Nombre de retweets",
    },
    selectedFilters,
    filterKey: "sort_field", // Matches a key in initialTwitterArticlesFilters
    onChange: fetchArticles,
  });

// All filters in wanted display order with their labels
const filtersNames = {
  group: "Groupe",
  major_stakeholder: "Grande Partie Prenante",
  stakeholder: "Partie Prenante",
  level: "Niveau",
  circo_name: "Localité",
};

const activeFilters = computed(() => {
  let arr = [];
  // Put all selected options from all filters with said filter name in an array for the SelectedFilters component
  Object.keys(filtersNames).forEach((key) => {
    selectedFilters.value[key]?.forEach((filter) => {
      arr = [...arr, { filter: key, item: filter }];
    });
  });
  return arr;
});
const showScrollTop = computed(() => selectedFilters.value.size > 20);

const addFilterItem = (event) => {
  let targetFilters = selectedFilters.value[event.filter] ?? [];
  targetFilters = [...targetFilters, event.item];

  selectedFilters.value = {
    ...selectedFilters.value,
    [event.filter]: targetFilters,
  };

  fetchArticles();
};

const removeFilterItem = (event) => {
  let targetFilters = selectedFilters.value[event.filter] ?? [];

  targetFilters = targetFilters.filter((el) => el !== event.item);

  if (targetFilters.length === 0) {
    delete selectedFilters.value[event.filter];
  } else {
    selectedFilters.value = {
      ...selectedFilters.value,
      [event.filter]: targetFilters,
    };
  }

  fetchArticles();
};

const resetFilter = (event) => {
  delete selectedFilters.value[event];
  fetchArticles();
};

const resetAllFilters = () => {
  store.resetFilters();
  fetchArticles();
};
</script>

<style lang="scss" scoped>
.social-media-article__title {
  display: flex;
  align-items: center;
  gap: 4px;

  & > .title-large-semibold {
    margin: 0;
  }
}
</style>
